import { useEffect, useState } from "react";
import { PageTab, PageTitle, Button, NewTab } from "../../components";
import TimesheetNotification from "./WfNotificationTabs/TimesheetNotification";
import Onboarding from "./WfNotificationTabs/Onboarding";
import AccountPayable from "./WfNotificationTabs/AccountPayable";
import PlacementAlerts from "./WfNotificationTabs/PlacementAlerts";
import IncomingPlacementsTab from "./WfNotificationTabs/IncomingPlacements/IncomingPlacementsTab";
import { fetchTotalCounts, updateTotalCountToStore } from "../../utils/wf-notifications";
import { useLoginUser } from "../../hooks/useLoginUser";
import { useSelector } from "react-redux";
import axiosRequest from "../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../redux/apiConfig";

const Notifications = () => {
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const notificationStore = useSelector((state) => state.wfNotification);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalCounts, setTotalCounts] = useState({});
  console.log({ totalCounts });

  const handleApprove = () => {
    setSelectedRows([]);
  };
  const fetchWFNotificationsTotalCount = async () => {
    // Fetch notification-based counts
    const notifCountsPromise = fetchTotalCounts({
      categories: [
        {
          name: "Timesheet",
          db: "Timesheet",
          extrafilters: {
            "isRead.status": { type: "NONE", value: false },
          },
        },
        { name: "AccountPayable", db: "AccountPayable" },
        { name: "Onboarding", db: "Onboarding" },
        {name: "Placement Alerts",db: "Placement",extrafilters: {event: { type: "NONE", value: "server.placement_closing_alert" },},},
      ],
      filters: {
        userId: { type: "NONE", value: loginUserUiid },
      },
    });

    // Fetch IncomingPlacement count directly from its own collection
    const incomingCountPromise = axiosRequest({
      method: "GET",
      url: ENDPOINTS.INCOMING_PLACEMENTS.GET_TOTAL_COUNT,
      params: {
        coll: "IncomingPlacement",
        fil: JSON.stringify({ status: { type: "NONE", value: "Pending" } }),
      },
    });

    const [res, incomingRes] = await Promise.all([notifCountsPromise, incomingCountPromise]);

    console.log({ res, incomingRes });
    const mapped = {
      newPlacements: incomingRes?.data?.data || 0,
      timesheet: res.find((x) => x.category === "Timesheet")?.count || 0,
      accountPayable:
        res.find((x) => x.category === "AccountPayable")?.count || 0,
      onboarding: res.find((x) => x.category === "Onboarding")?.count || 0,
      placementsAlerts:
        res.find((x) => x.category === "Placement Alerts")?.count || 0,
    };

    setTotalCounts(mapped);
  };
  useEffect(() => {
    //to fetch total counts for each entity
    fetchWFNotificationsTotalCount();
    updateTotalCountToStore({ userId: loginUserUiid })
  }, [notificationStore]);

  const NotificationMenus = [
    {
      title: "Timesheets",
      page: <TimesheetNotification totalCount={totalCounts?.timesheet || 0} fetchTotals={fetchWFNotificationsTotalCount} />,
      type: "main",
      value: totalCounts?.timesheet || 0,
    },
    {
      title: "Placement Alerts",
      page: <PlacementAlerts totalCount={totalCounts?.placementsAlerts || 0} fetchTotals={fetchWFNotificationsTotalCount} />,
      type: "main",
      value: totalCounts?.placementsAlerts || 0,
    },
    {
      title: "Account Payables",
      page: <AccountPayable totalCount={totalCounts?.accountPayable || 0} fetchTotals={fetchWFNotificationsTotalCount} />,
      type: "main",
      value: totalCounts?.accountPayable || 0,
    },
    {
      title: "Onboarding",
      page: <Onboarding totalCount={totalCounts?.onboarding || 0} fetchTotals={fetchWFNotificationsTotalCount} />,
      type: "main",
      value: totalCounts?.onboarding || 0,
    },
    {
      title: "New Placements",
      page: <IncomingPlacementsTab totalCount={totalCounts?.newPlacements || 0} />,
      type: "main",
      value: totalCounts?.newPlacements || 0,
    }
  ];
  return (
    <div className="pt-2">
      <div className="flex justify-between items-center px-4">
        <PageTitle title={"Notifications"} />

        {/* <Button
          type="button"
          title="Approve"
          variant="outlined"
          // onClick={handleApprove}
          color="primary"
          size="sm"
        />*/}
      </div>

      <div className="pt-5">
        <NewTab
          tabs={NotificationMenus}
          color="black"
          variant="outlined"
          mode="url"
          tabId="notifications"
        />
      </div>
    </div>
  );
};

export default Notifications;
